import { hasKaiAnalysis } from "@/pages/TriagePage/application/useTriage.selector"
import { IssueDescriptionKai } from "../IssueDescriptionKai"

import type { FindingKai } from "@/domain/issue"
import type { IssueDTO } from "@/pages/TriagePage/application/useTriage.types"

export const SastIssueDescriptionKai = (props: { issue?: IssueDTO }) => {
  const aggregatedKaiFindings = props.issue?.aggregatedKaiFindings

  if (!aggregatedKaiFindings || !props.issue) return null
  if (!hasKaiAnalysis(props.issue)) return null

  const irrelevantItems = (aggregatedKaiFindings.irrelevant ||
    []) as FindingKai[]
  const positiveItems = (aggregatedKaiFindings.positive || []) as FindingKai[]
  const undeterminedItems = (aggregatedKaiFindings.undetermined ||
    []) as FindingKai[]

  const allItems = [...irrelevantItems, ...positiveItems, ...undeterminedItems]
  const analyzing =
    allItems.length > 0 && allItems.every((item) => item.inProgress)

  return (
    <IssueDescriptionKai
      irrelevantItems={irrelevantItems}
      positiveItems={positiveItems}
      undeterminedItems={undeterminedItems}
      analyzing={analyzing}
    />
  )
}
